import App from './main';
import { mountIsland } from './mountIsland';

mountIsland('app', App)
//mountIsland('app-bar', require('./islands/MainAppBarIsland').default)
//mountIsland('sidebar', require('./islands/MainSidebarIsland').default)
//mountIsland('on-demand-export-island', require('./islands/OnDemandExportIsland').default)
//mountIsland('daily-usage-summary-report-island', require('./islands/DailyUsageSummaryReportIsland').default)
//mountIsland('monthly-consumption-report-island', require('./islands/MonthlyConsumptionReportIsland').default)
//mountIsland('data-completeness-report-island', require('./islands/DataCompletenessReportIsland').default)
